import { IFirmwareConfig } from ".";

export const DR750X_LTE_Plus = {
  default: {
    Time: {
      GpsSync: {},
      TimeSet: {},
    },
    Video: {
      ImageSetting: {
        options: [{ key: "0", value: "FHD@60 + FHD@30" }],
      },
      VideoQuality: {
        options: [
          { key: "0", value: "Highest(Extreme)" },
          { key: "1", value: "Highest" },
          { key: "2", value: "High" },
          { key: "3", value: "Normal" },
        ],
      },
    },

    Recording: {
      NormalRecord: {},
      AutoParking: {},
      RearParkingMode: {
        explain: "ON: front and_",
      },
      VoiceRecord: {},
      DateDisplay: {},
      SpeedUnit: {},
      UseGpsInfo: {},
      RecordTime: {
        options: [
          {
            key: "1",
            value: "1 min",
          },
        ],
      },
      LockEvent: {},
      FrontRotate: {},
      RearRotate: {
        options: [
          {
            key: "0",
            value: "Default",
          },
          {
            key: "1",
            value: "Rotate video 180°",
          },
          {
            key: "2",
            value: "Mirror video",
          },
        ],
      },
    },
    Gsensor: {
      Normal: {},
      Parking: {},
    },
    MotionDetection: {
      MOTIONSENSOR: {},
    },
    System: {
      LED: {
        RECLED: {},
        NORMALLED: {},
        PARKINGLED: {},
        RearLED: {},
        WifiLED: {},
        BTLED: {},
        LTELED: {},
      },
      PSENSOR: {},
      VoiceGuidance: {
        STARTVOICE: {},
        NORMALSTARTVOICE: {},
        EVENTSTARTVOICE: {},
        CHANGERECORDMODEVOICE: {},
        ENDVOICE: {},
        SPEEDALERTVOICE: {},
        PARKINGEVENTVOICE: {},
        CLOUDVOICE: {},
        CHANGECONFIGVOICE: {},
        SHARPTURNVOICE: {},
        HARSHBRAKINGVOICE: {},
        ACCELERATIONVOICE: {},
      },
      VOLUME: {},
      ScheduledReboot: {},
      SpeedAlert: {},
      EventRev: {},
      UserTextOverlay: {},
    },
    Wifi: {
      LoginCredentials: {},
      WifiSleepMode: {},
      onstart_LTE: {},
    },
    Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
    FirmwareLanguage: [
      "English",
      "Japan",
      "China",
      "German",
      "French",
      "Thai",
      "Idn",
      "Vietnam",
      "Spain",
      "Italian",
      "Dutch",
      "Polish",
      "Norwegian",
      "Finnish",
      "Arabic",
      "Korea",
    ],
  } as IFirmwareConfig,
  1.003: {
    DMS: {},
    System: {
      Seamless: {},
    },
  } as IFirmwareConfig,
  1.005: {
    System: {
      EventRev: undefined,
      EventRev2: {},
    },
  } as IFirmwareConfig,
  1.006: {
    CloudNative: {},
    // CloudNative3: {},
  },
};
